/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/consistent-type-assertions */

import axios, { AxiosResponse } from 'axios'

import { INNER_STORE, PARAMS } from './constants'
import { put } from './inner-store'
import { interceptor } from './interceptor'
import { refreshOnTime } from './refresh-on-time'
import { iAuthResponse } from './types'
import { urlUtils } from './utils'

export interface iRedirectedConfig {
  authServerTokenSSOUri?: string
  autoRefresh: boolean
}

const thirdPartyAuthentication = async ({
  authServerTokenSSOUri,
  autoRefresh,
}: iRedirectedConfig): Promise<iAuthResponse> => {
  // recupera los datos de la URL
  const xAuth = urlUtils.getQueryParam(PARAMS.auth)

  const body = {
    grant_type: 'authorization_code',
  } as Record<string, string>

  const { data } = await axios.request<
    typeof body,
    AxiosResponse<iAuthResponse>
  >({
    url: authServerTokenSSOUri,
    method: 'post',
    data: body,
    headers: {
      'x-Authorization': xAuth !== null ? xAuth : '',
    },
  })

  put(INNER_STORE.auth, { ...data, isAuthenticated: true })
  interceptor()

  if (autoRefresh) refreshOnTime()

  return data
}

export { thirdPartyAuthentication }
